import Link from '@/components/utilities/SmartLink';

const GlossarySidebarCta = ({ title, description, buttonLabel, buttonLink, note }) => {
  if (!title && !buttonLabel) return null;

  return (
    <div className="bg-grey-950 rounded-2xl p-6 text-white">
      {title && <h3 className="mb-3 text-lg text-white">{title}</h3>}
      {description && <p className="mb-5 text-sm leading-relaxed text-white/60">{description}</p>}
      {buttonLabel && buttonLink && (
        <Link
          href={buttonLink}
          className="bg-brand-500 hover:bg-brand-600 flex w-full items-center justify-center rounded-full px-5 py-3 text-sm font-medium text-white transition-colors"
        >
          {buttonLabel}
        </Link>
      )}
      {note && <p className="mt-3 text-center text-xs text-white/35">{note}</p>}
    </div>
  );
};

export default GlossarySidebarCta;
